import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import './AdmitPatientEvent.scss'
import moment from 'moment'
import MobiScrollCalendar from '../../../../../../components/common/MobiScrollCalendar/MobiScrollCalendar'
import DischargePatientEventModal from './DischargePatientEventModal'
import { DischargeIcon } from '../../../../../../components/common/shared/sharedPatientCode'

// the special admit date that Medrina wants
export default function DischargePatientEventCard({
  visit,
  onChange,
  currentPatientDischargeDate,
  currentPatientAdmitDate,
  current_service_date_from,
}) {
  const features = useSelector((state) => state?.user?.features) || []

  const [showModal, setShowModal] = useState(false)
  const patientDischargeDate = currentPatientDischargeDate || visit?.dischargePatientEvent?.date
  const patientAdmitDate = currentPatientAdmitDate || visit?.admitPatientEvent?.date

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <div className="admit-date-selector admit-date-card" onClick={() => setShowModal(true)}>
          <div className="label d-flex gap-2">
            Discharge Date
            <DischargeIcon features={features} visit={visit} />
          </div>
          <div className="admit-date-input">
            <MobiScrollCalendar
              placeholder="MM / DD / YYYY"
              value={
                patientDischargeDate ? moment.utc(patientDischargeDate).format('MM/DD/YYYY') : ''
              }
              disabled={true}
            ></MobiScrollCalendar>
          </div>
        </div>
      </div>
      {showModal && (
        <DischargePatientEventModal
          date={patientDischargeDate}
          visit={{
            ...visit,
            service_date_from: current_service_date_from,
            ...(!patientDischargeDate && { dischargePatientEvent: null }),
          }}
          isPatientEventCard={true}
          onClose={() => {
            setShowModal(false)
          }}
          onChange={(newDate) => {
            setShowModal(false)
            onChange(newDate)
          }}
          min={patientAdmitDate !== 'DISCHARGE' ? patientAdmitDate : null}
        />
      )}
    </>
  )
}
